/*
 * @Description: Description
 * @version: 1.0.0
 * @Author: FJW
 * @Date: 2024-08-28 13:44:46
 * @LastEditors: FJW
 * @LastEditTime: 2024-12-13 16:55:01
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
// import Register from '../view/Register'
import Home from '../view/Home'

// 安装路由
Vue.use(VueRouter);

const router = new VueRouter({
  ignoreDuplicates: true,
  routes: [{
    path: "/",
    redirect: "/login"
  },
  {
    name: "Login",
    path: '/login',
    component: Login
  },
  // {
  //   name: "Register",
  //   path: '/register',
  //   component: Register
  // },
  {
    name: "Home",
    path: '/home',
    component: Home,
    children: [
      {
        name: "Chat",
        path: "/home/chat",
        component: () => import("../view/Chat"),
      },
      {
        name: "Friends",
        path: "/home/friend",
        component: () => import("../view/Friend"),
      },
      // {
      //   name: "Friends",
      //   path: "/home/group",
      //   component: () => import("../view/Group"),
      // }
    ]
  },
  {
    path: '*',
    redirect: '/login'
  }
  ]

})

router.beforeEach((to, from, next) => {
  const isLoggedIn = !!sessionStorage.getItem("accessToken");

  if (to.path === '/login') {
    next()
    return
  }

  if (!isLoggedIn) {
    next('/login')
  } else {
    next()
  }
})


// 配置导出路由
export default router
